import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerDetailPage from "../pages/DsokCustomerDetailPage";

export const dsokCustomerDetailRoute = {
  path: "/dsok/customer-detail/:customerUrl",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerDetailPage} />
    </DsokCustomerDetailProvider>
  ),
};
